<body>
  <div>
    <table class="table2">
      <thead>
        <th class="corlinha">
          Criar Time Table
        </th>
      </thead>
    </table>
    <div class="table2">
      <label for="startDate" class="meu-label">Data da Programação:</label>
      <input type="date" id="startDate" [(ngModel)]="startDate" name="startDate" class="button-spacing">
      <button (click)="salvar()" class="button-spacing">Gerar Programação</button>
      <button (click)="editDialog('')" class="button-spacing"><i-feather name="plus-circle"></i-feather>Adicionar
        Viagem</button>
      <div *ngIf="showProgressBar">
        <progressbar [value]="progressValue" [max]="maxValue">{{ progressValue }} Saved lines</progressbar>
      </div>
      <a #downloadLink style="display: none;"></a>
      <div class="table2">
        <table>

          <thead>
            <tr>
              <th class="auto-width">
                Transportadora
              </th>
              <th class="auto-width">
                Tipo Veiculo
              </th>
              <th class="auto-width">
                Placa Cavalo
              </th>
              <th class="auto-width">
                Placa Carreta
              </th>
              <th class="auto-width">
                Rota
              </th>
              <th class="auto-width">
                Viagem
              </th>
              <!--<th class="auto-width">
                Janela
              </th> -->
              <th class="auto-width">
                Doca
              </th>
              <th class="auto-width">
                Janela
              </th>
              <!-- <th class="auto-width">
                Observação
              </th> -->
              <th class="auto-width">
                Editar
              </th>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngFor="let item of programacao">
              <tr>
                <td>{{ item.Transportadora }}</td>
                <td>{{ item['Transport Type'] }}</td>
                <td>{{ item.Plate }}</td>
                <td>{{ item.trailerPlate }}</td>
                <td>{{ item.rota }}</td>
                <td>{{ item.viagem }}</td>
                <!-- <td>{{ item.Janela }}</td>  -->
                <td [ngClass]="{
                  'R22': item['Local'] === 'R22',
                  'R26': item['Local'] === 'R26',
                  'R27': item['Local'] === 'R27',
                  'R54': item['Local'] === 'R54',
                  'R16': item['Local'] === 'R16',
                  'R19': item['Local'] === 'R19',
                  'R56': item['Local'] === 'R56',
                  'E37': item['Local'] === 'E37',
                  'PRU': item['Local'] === 'PRU',
                  'E56': item['Local'] === 'E56',
                  'R4': item['Local'] === 'R4',
                  'R3': item['Local'] === 'R3',
                  'R29': item['Local'] === 'R29',
                  'P40': item['Local'] === 'P40',
                  'R40': item['Local'] === 'R40',
                  'R43': item['Local'] === 'R43',
                  'VAZIO': item['Local'] === undefined
                }">
                  <h3 class="my-heading">{{ item['Local'] }}</h3>
                  <!-- <h4 class="my-subheading">{{ item['Janela 1'] | date: 'HH:mm' }}</h4> -->
                </td>
                <!-- <td>{{ item.observacao }}</td> -->
                <td>
                  <h4 class="my-subheading">{{ item['Janela'] | date: 'HH:mm' : '+00:00' }}</h4>
                </td>
                <td>
                  <i-feather name="edit" (click)="editDialog(item)"></i-feather>
                  <i-feather name="delete" (click)="deleteItem(item.ID)" class="button-spacing"></i-feather>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</body>
<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'md'" class="dialog-container">

  <h3 class="modal-title">Ajuste de Programação</h3>
  <div class="modal-body">
    <form class="inputs">
      <table class="table2000">
        <tr>
          <td>
            <label class="modal-label">Transportadora</label>
          </td>
          <td>
            <select id="transportadora" name="transportadora" [(ngModel)]="item.Transportadora" class="modal-select">
              <option *ngFor="let nome of transportadora" [value]="nome">{{ nome }}</option>
            </select>
          </td>
          <!-- <td style="width: 100px;">
            <label class="modal-label">Tipo de Veículo</label>
          </td>
          <td style="width: 250px;">
            <select id="tipoVeiculo" name="tipoVeiculo" [(ngModel)]="item.modelo" class="modal-select">
              <option *ngFor="let nome of veiculos" [value]="nome.modelo">{{ nome.modelo }}</option>
            </select>
          </td> -->
          <td>
            <label class="modal-label">Placa Cavalo</label>
          </td>
          <td>
            <input type="string" name="Plate" [(ngModel)]="item.Plate" class="modal-input1">
          </td>
          <td>
            <label class="modal-label">Placa Carreta</label>
          </td>
          <td>
            <input type="string" name="trailerPlate" [(ngModel)]="item.trailerPlate" class="modal-input1">
          </td>
        </tr>
      </table>

      <table class="table2000">
        <tr>
          <td>
            <label class="modal-label">Rota</label>
          </td>
          <td>
            <input type="string" name="rota" [(ngModel)]="item.rota" class="modal-input1">
          </td>
          <td>
            <label class="modal-label">Viagem</label>
          </td>
          <td>
            <input type="string" name="viagem" [(ngModel)]="item.viagem" class="modal-input1">
          </td>
          <td>
            <label class="modal-label">Local</label>
          </td>
          <td style="width: 250px;">
            <select id="local" name="local" [(ngModel)]="item['Local']" class="modal-select1">
              <option *ngFor="let local of locais" [value]="local">{{ local }}</option>
            </select>
          </td>
          <td>
            <label class="modal-label">Janela</label>
          </td>
          <td style="width: 250px;">
            <input type="time" id="Janela" name="Janela" [(ngModel)]="janela" placeholder="HH:mm" required
              class="modal-input1" />
          </td>

        </tr>
      </table>

      <div class="modal-div">
        <button class="modal-button" type="button" (click)="salvar2(item)">Save</button>
        <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</clr-modal>

<div *ngIf="isLoading" class="spinner-overlay">
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
</div>